<div class="heatmap-container">
    <table>
        <tr>
            <td>
                <table>
                    <tr>
                        <td></td>
                        <td *ngFor="let month of months" colspan="4">{{ month }}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td *ngFor="let week of weeks" [class]="getDayActivityClassName(7, week)"></td>
                    </tr>
                    <tr>
                        <td rowspan="2">
                            <span class="day-title">Monday</span>
                        </td>
                        <td *ngFor="let week of weeks" [class]="getDayActivityClassName(1, week)"></td>
                    </tr>
                    <tr>
                        <!--<td></td>-->
                        <td *ngFor="let week of weeks" [class]="getDayActivityClassName(2, week)"></td>
                    </tr>
                    <tr>
                        <td rowspan="2">
                            <span class="day-title">Wednesday</span>
                        </td>
                        <td *ngFor="let week of weeks" [class]="getDayActivityClassName(3, week)"></td>
                    </tr>
                    <tr>
                        <!--<td></td>-->
                        <td *ngFor="let week of weeks" [class]="getDayActivityClassName(4, week)"></td>
                    </tr>
                    <tr>
                        <td rowspan="2">
                            <span class="day-title">Friday</span>
                        </td>
                        <td *ngFor="let week of weeks" [class]="getDayActivityClassName(5, week)"></td>
                    </tr>
                    <tr>
                        <!--<td></td>-->
                        <td *ngFor="let week of weeks" [class]="getDayActivityClassName(6, week)"></td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td>
                <table style="float: right;">
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td rowspan="2" class="day-title">Less</td>
                        <td class="heatmap-tile activity-none"></td>
                        <td class="heatmap-tile activity-lowest"></td>
                        <td class="heatmap-tile activity-medium-low"></td>
                        <td class="heatmap-tile activity-medium-high"></td>
                        <td class="heatmap-tile activity-highest"></td>
                        <td rowspan="2" class="day-title">More</td>
                    </tr>
                    <tr>
                        <!--<td></td>-->
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <!--<td></td>-->
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</div>
